module.exports = __webpack_public_path__ + "img/wind-sock-cloth-500x500.b9b9cff9.png";